//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import thirdPartyButton from './_thirdPartyScriptButton'; ///* istanbul ignore next dynamic imports */

var genericModal = function genericModal() {
  return import(
  /* webpackChunkName: 'genericlModal' */
  '../Modals/genericModal');
};

export default {
  extends: thirdPartyButton,
  data: function data() {
    return {
      modalComponent: '',
      modalSettings: {},
      isModalVisible: false,
      displayName: '',
      floatingToolbarClass: '.floatingBox',
      unstackClass: 'unstack'
    };
  },
  components: {
    'genericModal': genericModal
  },
  watch: {
    button: function button() {
      this.displayName = this.button ? this.button.displayName : '';
    }
  },
  methods: {
    openModal: function openModal(event) {
      event.stopPropagation();
      this.setModal();
      this.performAction(event);
    },
    setModal: function setModal() {
      if (this.$_checkForprivacyOptOut(this.button) == true || !this.button) {
        return;
      } // if already open, close the modal on click


      if (this.isModalVisible) {
        this.stackToolbar();
        this.isModalVisible = false;
        return;
      }

      var settings = {
        headerText: this.button.modalHeader,
        contentValue: this.button.modalContent,
        modalClass: this.button.modalCssClass
      };
      this.showModal(settings);
    },
    showModal: function showModal(settings) {
      this.modalComponent = 'genericModal';
      this.modalSettings = settings;
      this.unstackToolbar();
      this.isModalVisible = true;
    },
    hideModal: function hideModal(event) {
      this.stackToolbar();
      this.isModalVisible = false;
      event.stopPropagation();
    },
    unstackToolbar: function unstackToolbar() {
      var floatingActionToolbars = document.querySelectorAll(this.floatingToolbarClass);

      for (var i = 0; i < floatingActionToolbars.length; i++) {
        floatingActionToolbars[i].classList.add(this.unstackClass);
      }
    },
    stackToolbar: function stackToolbar() {
      var floatingActionToolbars = document.querySelectorAll(this.floatingToolbarClass);

      for (var i = 0; i < floatingActionToolbars.length; i++) {
        floatingActionToolbars[i].classList.remove(this.unstackClass);
      }
    }
  }
};